import { initFlickitySlider } from './initFlickitySlider.js';

export function sliderMobile() {
	const sliders = document.querySelectorAll('.is-style-slider-mobile');
	if (!sliders.length) return;

	sliders.forEach(slider => {
		const alignment = 'center';
		const MOBILE_BREAKPOINT = 980; // md breakpoint

		// Function to check if we're on mobile
		const isMobile = () => window.innerWidth < MOBILE_BREAKPOINT;

		// Function to initialize slider
		const initSlider = () => {
			if (isMobile() && !Flickity.data(slider)) {
				initFlickitySlider(slider, alignment);
			}
		};

		// Function to destroy slider
		const destroySlider = () => {
			const flkty = Flickity.data(slider);
			if (!isMobile() && flkty) {
				flkty.destroy();
			}
		};

		// Initialize on load if mobile
		initSlider();

		// Handle resize
		let resizeTimer;
		window.addEventListener('resize', () => {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(() => {
				if (isMobile()) {
					initSlider();
				} else {
					destroySlider();
				}
			}, 250);
		});
	});
}
